module.exports = __webpack_public_path__ + "img/shoot_00040.b9032d40.png";